import styled from "styled-components";
import colors from "../../../../../../config/colors";
import fonts from "../../../../../../config/fonts";
import { isMobile } from "../../../../../../utils/common";

export const AreaGraphCardContainer = styled.div`
  margin: 10px;
  background-color: ${colors.background};
  width:  calc(100vw - 480px);
  border-radius: 5px;
  ${isMobile() &&
  `
            width:calc(100vw - 40px);
  `}
`;

export const TitleLine = styled.div`
  font-size: 20px;
  ${fonts.headings};
  font-weight: bold;
`;

export const ChartContainer = styled.div`
  min-width: calc(100vw - 480px);
  width: calc(100vw - 480px);
  height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${isMobile() &&
  `
        min-width:calc(100vw - 40px);
            width:calc(100vw - 40px);
        height: 50vh;
        `}
`;

export const TopSection = styled.div`
  padding: 10px;
  border-bottom: solid 1px ${colors.darkBackground};
`;
export const DataSummary = styled.div`
  min-height: 82px;
  ${(props) =>
    props.isLoading &&
    `
        display:flex;
        align-items:center;
        justify-content:center;
      `}
`;
export const ValueLine = styled.div`
  padding-top: 5px;
  display: flex;
  align-items: flex-end;
`;
export const ValueText = styled.div`
  font-size: 36px;
  padding-right: 6px;
`;
export const ValueUnit = styled.div`
  font-size: 16px;
  opacity: 0.62;
  padding-bottom: 5px;
`;

export const ChangeLine = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.color};
`;
export const DirectionArrow = styled.div`
  margin-right: 5px;
`;
export const PercentChange = styled.div`
  font-size: 16px;
  padding-bottom: 5px;
  margin-right: 5px;
`;

export const DurationText = styled.div`
  padding-bottom: 5px;
`;
